"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Color;
(function (Color) {
    Color["Primary"] = "+1";
    Color["Secondary"] = "+2";
    Color["Quiet"] = "+quiet";
    Color["Positive"] = "+pos";
    Color["Negative"] = "+neg";
    Color["Warning"] = "+warn";
    Color["Reverse"] = "+rev";
})(Color || (Color = {}));
;
var Type;
(function (Type) {
    Type["Ghost"] = "+ghost";
    Type["Text"] = "+text";
})(Type || (Type = {}));
;
var Size;
(function (Size) {
    Size["Small"] = "+small";
    Size["Large"] = "+large";
    Size["Inline"] = "+inline";
})(Size || (Size = {}));
var Shape;
(function (Shape) {
    Shape["Long"] = "+long";
    Shape["Tighter"] = "+tighter";
    Shape["Tight"] = "+tight";
})(Shape || (Shape = {}));
;
exports.Button = function (props) {
    // Destructure our props, so that we can get the rest of our props to pass
    // through to our HTML input
    var color = props.color, type = props.type, size = props.size, shape = props.shape, noHover = props.noHover, onClick = props.onClick, disabled = props.disabled, allowOverlappingEvents = props.allowOverlappingEvents, rest = __rest(props, ["color", "type", "size", "shape", "noHover", "onClick", "disabled", "allowOverlappingEvents"]);
    // Track if we're busy - toggled during a button push.
    var _a = react_1.useState(false), busy = _a[0], setBusy = _a[1];
    var classes = __spreadArrays([
        'c-button',
        color,
        type,
        size,
        shape,
        disabled ? "+disabled" : "",
        busy ? "+busy" : "",
        noHover ? "+no-hover" : ""
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("button", __assign({ className: classes.join(' '), disabled: disabled || busy, onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!onClick) return [3 /*break*/, 3];
                        if (!!allowOverlappingEvents) return [3 /*break*/, 2];
                        // Disable while we're processing
                        setBusy(true);
                        // Call our click event and wait for it to return
                        return [4 /*yield*/, onClick(e)];
                    case 1:
                        // Call our click event and wait for it to return
                        _a.sent();
                        // Re enable our button.
                        setBusy(false);
                        return [3 /*break*/, 3];
                    case 2:
                        // User doesn't want to wait - just call the event handler.
                        onClick(e);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); } }, rest), props.children);
};
exports.Buttons = function (props) {
    var classes = __spreadArrays([
        'c-buttons'
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' ') }, props.children);
};
exports.Button.Color = Color;
exports.Button.Type = Type;
exports.Button.Size = Size;
exports.Button.Shape = Shape;
exports.Button.Group = exports.Buttons;
//# sourceMappingURL=Button.js.map